import React, { useEffect, useState, useContext } from 'react';
import CryptoJS from 'crypto-js';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppAgendaContext } from '../context/AppAgendaContext';
import WizardPaso1 from '../components/WizardPaso1';
import GlobalStyles from '../styles/globalStyles';
import {
  ModalText, Divider, ModalCardTitle, ModalInfoText, ModalSubText
} from '../styles/formStyles';
import {
  Container, Content, Title, Subtitle, AuthMessage, Form, FormGroup,
  Label, Input, Spacer, ButtonGroup as ButtonGroupStyled, Button
} from '../styles/pacienteStyles';
import {
  authenticateUser, getPacienteInfo,
  getAgendamientosPaciente, cambiarEstadoAgendamiento
} from '../services/api/authService';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { resolverFlujoEncriptado } from '../utils/resolverFlujoEncriptado';

const IndexPac = () => {    
  const navigate = useNavigate();
  const location = useLocation();
  const {
    updatePacienteInfo,
    resetContextData,
    updateContextData,
    updatePacienteEstado,
    setContextData,
    setUtmData,
    setUltimoEventoGTM,
    setPasoActual,
    sessionId,
    utmData,
    flujoActivo,
    contextData,
    setFlujoActivo,    
    registrarEventoVisual
  } = useContext(AppAgendaContext);
  const [rut, setRut] = useState(() => sessionStorage.getItem('rut') || '');
  const [authMessage] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [agendamiento, setAgendamiento] = useState(null);
  const [pacienteNombre, setPacienteNombre] = useState('');
  const [inicioLogeado, setInicioLogeado] = useState(false);
  const { logEventoBD } = useContext(AppAgendaContext);

  const logEvento = async ({ paso, evento, descripcion, campo, valor }) => {
    const payload = {
      session_id: sessionId,
      paso,
      evento,
      descripcion,
      campo_afectado: campo || null,
      valor_ingresado: valor || null,
      fecha_evento: new Date().toISOString(),
      ...utmData,
      origen_referrer: document.referrer || null
    };
  };  
  
useEffect(() => {
  if (sessionStorage.getItem('flujoFinalizadoOK') === 'true') {
    sessionStorage.clear(); // borra todo, incluyendo la marca
    setPasoActual('IndexPac');

    Swal.fire({
      icon: 'success',
      title: '¡Reserva completada!',
      text: 'Tu cita fue agendada correctamente, por favor revisa tu correo electrónico.',
      confirmButtonText: 'OK',
      confirmButtonColor: '#00b3b3'
    });

    return;
  }

  if (sessionStorage.getItem('inicioOK') === 'true') {
    // console.log("🔄 Ya validado previamente, evitando revalidación");
    return;
  }
  sessionStorage.clear();  
  resetContextData();

  const queryParams = new URLSearchParams(window.location.search);
  const mp_origen = queryParams.get('mp_origen');

  const mp_flujo_encriptado = queryParams.get('mp_flujo');
  const resultado = resolverFlujoEncriptado(mp_flujo_encriptado);

  if (resultado) {
    sessionStorage.setItem('url_mpTipoTxt', resultado.tipo);
    sessionStorage.setItem('url_mpTipoVal', resultado.valor);
    sessionStorage.setItem('claveFlujo', resultado.clave);

    // Si NO tiene sucursalesPermitidas, asignar por defecto TODAS
    if (!resultado.sucursalesPermitidas || !Array.isArray(resultado.sucursalesPermitidas)) {
      resultado.sucursalesPermitidas = [1, 2, 5, 8, 9];
    }

    // Actualiza contexto global
    setContextData(prev => ({
      ...prev,
      url_mpTipoTxt: resultado.tipo,
      url_mpTipoVal: resultado.valor,
      claveFlujo: resultado.clave,
      sucursalesPermitidas: resultado.sucursalesPermitidas
    }));

    // Actualiza contexto de flujo
    setFlujoActivo(resultado);
    sessionStorage.setItem('flujoActivo', JSON.stringify(resultado));

    // console.log("✅ mp_flujo resuelto:", resultado.clave);

  } else {
    console.warn("⚠️ No se pudo resolver flujo, usando valor por defecto.");

    const flujoDefault = {
      clave: 'default',
      tipo: 'odontrut',
      valor: '10276218',
      descripcion: 'Flujo por defecto (producción)',
      sucursalesPermitidas: [1, 2],
      inicioOK: true,
      firma: null,
      firmaValida: false,
      mp_origen,
      pasosPermitidos: [
        'IndexPac',
        'SeleccionaTipoHora',
        'SeleccionaFecHora',
        'ConfirmaFonoMail',
        'ConfirmaPaciente',
        'ConfirmaAgendamiento'
      ],
      origen: location.href
    };

    setContextData(prev => ({
      ...prev,
      url_mpTipoTxt: 'odontrut',
      url_mpTipoVal: '10276218',
      claveFlujo: 'default',
      sucursalesPermitidas: flujoDefault.sucursalesPermitidas
    }));

    setFlujoActivo(flujoDefault);
    sessionStorage.setItem('flujoActivo', JSON.stringify(flujoDefault));
  }



  // Guardar temporalmente UTM
  setUtmData({
    source: queryParams.get('utm_source') || '-',
    medium: queryParams.get('utm_medium') || '-',
    campaign: queryParams.get('utm_campaign') || '-',
    term: queryParams.get('utm_term') || '-',
    content: queryParams.get('utm_content') || '-',
  });

/*  const flujoValido = iniciarFlujoSeguro({
    origen: location.href,
    tipo_flujo,
    mp_origen,
    firma
  });

  if (!flujoValido) {
    registrarEventoVisual({
      paso: 'IndexPac',
      evento: 'flujo_bloqueado',
      descripcion: `Firma inválida para tipo_flujo: ${tipo_flujo}, origen: ${mp_origen}`
    });

    Swal.fire({
      icon: 'error',
      title: 'Enlace no autorizado',
      text: 'El enlace utilizado no es válido o ha sido manipulado.',
    }).then(() => navigate('/IndexPac'));

    return;
  } */

  // ✅ Firma válida → limpiar la URL
  const cleanUrl = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);

  // Guardar en sessionStorage para pasos posteriores
  sessionStorage.setItem('inicioOK', 'true');
  sessionStorage.setItem('mp_origen', mp_origen);

  // Inicializar el flujo manualmente
  const flujo = {
    ...(resultado || {}),
    inicioOK: true,
    firma: null,
    firmaValida: false,
    origen: location.href,
    mp_origen,
    pasosPermitidos: [
      'IndexPac',
      'SeleccionaTipoHora',
      'SeleccionaFecHora',
      'ConfirmaFonoMail',
      'ConfirmaPaciente',
      'ConfirmaAgendamiento'
    ]
  };

  sessionStorage.setItem('flujoActivo', JSON.stringify(flujo));
  setFlujoActivo(flujo);

  const authenticate = async () => {
    try {
      const usuario = process.env.REACT_APP_API_USER;
      const password = process.env.REACT_APP_API_PASS;
      await authenticateUser(usuario, password);
    } catch (error) {
      console.error('Error de autenticación:', error);
    }
  };

  authenticate();

  if (rut.trim() !== '') {
    setIsButtonDisabled(false);
  }
}, []);


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const origenParam = queryParams.get('o');
    const tipoParam = queryParams.get('t');

    if (origenParam || tipoParam) {
      setContextData(prev => ({
        ...prev,
        paginaOrigen: origenParam || null,
        paginaTipo: tipoParam || null
      }));
    }
  }, [location.search, setContextData]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
  
    const utmParams = {
      source: queryParams.get("utm_source"),
      medium: queryParams.get("utm_medium"),
      campaign: queryParams.get("utm_campaign"),
      term: queryParams.get("utm_term"),
      content: queryParams.get("utm_content"),
    };
  
    // Verifica si ya están en sessionStorage antes de setearlos
    Object.entries(utmParams).forEach(([key, value]) => {
      const storageKey = `utm_${key}`;
      if (value && !sessionStorage.getItem(storageKey)) {
        sessionStorage.setItem(storageKey, value);
      }
    });
  
    // Actualiza el contexto con lo almacenado
    const storedUtm = {
      source: sessionStorage.getItem("utm_source"),
      medium: sessionStorage.getItem("utm_medium"),
      campaign: sessionStorage.getItem("utm_campaign"),
      term: sessionStorage.getItem("utm_term"),
      content: sessionStorage.getItem("utm_content"),
    };
  
    if (
      storedUtm.source ||
      storedUtm.medium ||
      storedUtm.campaign ||
      storedUtm.term ||
      storedUtm.content
    ) {      
      setUtmData(storedUtm);
    }
  }, [location.search]);

  useEffect(() => {
    const tieneDispositivo = contextData?.dispositivoTipo;
    const tieneFlujo = flujoActivo?.mp_origen !== null;
    const tieneUTM = utmData?.source !== undefined;

    if (!inicioLogeado && sessionId && tieneDispositivo && tieneFlujo && tieneUTM) {
      logEventoBD({
        paso: 'IndexPac',
        evento: 'inicio_flujo',
        descripcion: 'El usuario ingresó al sitio Index'
      });
      setInicioLogeado(true);
    }
  }, [inicioLogeado, sessionId, contextData, flujoActivo, utmData]);

  useEffect(() => {
    // Disparar evento solo una vez al montar IndexPac
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "inicio_flujo" });
  
    setUltimoEventoGTM("inicio_flujo");
  }, []); 
  
  useEffect(() => {
    const tieneInfoCliente = contextData?.dispositivoTipo && contextData?.sistemaOperativo && contextData?.navegador;

    if (sessionId && flujoActivo?.clave && tieneInfoCliente) {
      logEventoBD({
        paso: 'IndexPac',
        evento: 'flujo_detectado',
        descripcion: 'Flujo inicial detectado desde mp_flujo',
        campo: 'mp_origen',
        valor: flujoActivo.clave
      });
    }
  }, [sessionId, flujoActivo, contextData]);

  const formatRut = (value) => {
    let rut = value.replace(/[.-]/g, '');
    if (rut.length > 1) {
      let cuerpo = rut.slice(0, -1);
      let dv = rut.slice(-1);
      cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return `${cuerpo}-${dv}`;
    }
    return rut;
  };

  const validarRut = (rut) => {
    // Eliminar puntos y guion
    rut = rut.replace(/[.-]/g, '');

    // Validar estructura general: números + dígito verificador (número o K)
    if (!/^[0-9]+[kK0-9]$/.test(rut)) return false;

    let cuerpo = rut.slice(0, -1);
    let dv = rut.slice(-1).toUpperCase();
    let cuerpoNum = parseInt(cuerpo, 10);

    // Rango válido para personas naturales en Chile
    if (cuerpoNum < 1000000 || cuerpoNum > 35000000) return false;

    // Excluir patrones ficticios o de prueba
    const rutInvalidos = [
      '11111111', '22222222', '33333333', '44444444',
      '55555555', '66666666', '77777777', '88888888', '99999999'
    ];
    if (rutInvalidos.includes(cuerpo)) return false;

    // Validación del dígito verificador
    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= cuerpo.length; i++) {
      suma += multiplo * parseInt(rut.charAt(cuerpo.length - i), 10);
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();

    return dv === dvEsperado;
  };

  const formatFechaISO = (fechaStr) => {
    const fecha = new Date(fechaStr);
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    const day = String(fecha.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatearFecha = (fechaStr) => {
    const fecha = new Date(fechaStr);
    const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return fecha.toLocaleDateString('es-ES', opciones);
  };

  const handleRutChange = (e) => {
    const newRut = formatRut(e.target.value);
    setRut(newRut);
    sessionStorage.setItem('rut', newRut);
    setIsButtonDisabled(newRut.trim() === '');
  };

  const handleRutBlur = () => {
    if (rut.trim() !== '') {
      logEventoBD({
        paso: 'IndexPac',
        evento: 'input_rut',
        descripcion: 'Usuario ingresó RUT',
        campo: 'rut',
        valor: rut
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarRut(rut)) {
      logEvento({
        paso: 'IndexPac',
        evento: 'rut_invalido',
        descripcion: 'Usuario ingresó un RUT no válido',
        campo: 'rut',
        valor: rut
      });

      Swal.fire({
        icon: 'error',
        title: 'RUT No Válido',
        text: 'El formato de RUT no es correcto. Por favor reintente',
      });
      return;
    }

    try {
      const formattedRut = rut.replace(/[.-]/g, '');
      const cuerpoRut = formattedRut.slice(0, -1);
      const dvRut = formattedRut.slice(-1);

      const response = await getPacienteInfo(cuerpoRut);

      if (response.codigo === 200 && response.datos.length > 0) {
        sessionStorage.setItem('pacienteInfo', JSON.stringify(response.datos[0]));
        setPacienteNombre(response.datos[0].pacNombre);

        logEvento({
          paso: 'IndexPac',
          evento: 'paciente_encontrado',
          descripcion: 'Paciente encontrado con información previa',
          campo: 'rut',
          valor: cuerpoRut
        });

        const agendamientosResponse = await getAgendamientosPaciente(cuerpoRut);

        updatePacienteInfo({
          pacRut: cuerpoRut,
          pacDv: dvRut,
          pacNombre: response.datos[0].pacNombre,
          pacCorreo: response.datos[0].pacCorreo,
          pacTelefono: response.datos[0].pacTelefono
        });

        updatePacienteEstado("Web2_r");

        if (agendamientosResponse.codigo === 200 && agendamientosResponse.datos.length > 0) {
          setAgendamiento(agendamientosResponse.datos[0]);
          setShowModal(true);
        } else {
          navigate('/SeleccionaTipoHora');
        }
      } else {
        logEvento({
          paso: 'IndexPac',
          evento: 'nuevo_paciente',
          descripcion: 'No se encontró paciente, se inicia nuevo flujo',
          campo: 'rut',
          valor: cuerpoRut
        });
        
        updatePacienteInfo({ pacRut: cuerpoRut, pacDv: dvRut, pacNombre: '', pacCorreo: '', pacTelefono: '' });
        updatePacienteEstado("Web2_p");
        navigate('/SeleccionaTipoHora');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error al consultar',
        text: `Ocurrió un error al consultar la información del paciente. RUT: ${rut.replace(/[.-]/g, '').slice(0, -1)}`,
      });
    }
  };

  const handleConfirmarAsistencia = async () => {
    if (!agendamiento?.AGE_ID) return;

    try {
      const response = await cambiarEstadoAgendamiento(agendamiento.AGE_ID, 'CONF');

      if (response.codigo === '200') {
        await logEventoBD({
          paso: 'IndexPac',
          evento: 'confirmar_asistencia',
          descripcion: 'Paciente confirmó asistencia a la hora agendada',
          campo: 'age_id',
          valor: agendamiento.AGE_ID
        });

        sessionStorage.setItem('agendamiento', JSON.stringify(agendamiento));

        updateContextData({
          doctorName: `${agendamiento.ODONT_NOMBRES} ${agendamiento.ODONT_APELLIDOS}`,
          ageFecha: formatFechaISO(agendamiento.FECHA),
          ageHora: agendamiento.HORARIO,
          sucursalNombre: agendamiento.SUCURSAL,
          sucursalDireccion: agendamiento.DIRECCION || '',
          odontRut: agendamiento.ODONT_RUT || null,
          horId: agendamiento.HOR_ID || null,
        });

        sessionStorage.setItem('agendamientoRealizado', 'true');
        navigate('/ConfirmaAgendamiento');
      } else {
        Swal.fire({ icon: 'error', title: 'Error al confirmar asistencia', text: response.message || 'Error inesperado.' });
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo confirmar la asistencia.' });
    }
  };

  const handleCancelarHora = async () => {
    if (!agendamiento?.AGE_ID) return;

    try {
      const response = await cambiarEstadoAgendamiento(agendamiento.AGE_ID, 'ANUL');

      if (response.codigo === '200') {
        await logEventoBD({
          paso: 'IndexPac',
          evento: 'cancelar_hora',
          descripcion: 'Paciente canceló su hora previamente agendada',
          campo: 'age_id',
          valor: agendamiento.AGE_ID
        });

        setShowModal(false);
        Swal.fire({
          icon: 'success',
          title: 'Hora Cancelada',
          text: 'La hora ha sido cancelada correctamente. ¿Desea agendar otra hora?',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) navigate('/SeleccionaTipoHora', { state: { rut } });
          else navigate('/IndexPac');
        });
      } else {
        Swal.fire({ icon: 'error', title: 'Error al cancelar', text: response.message || 'Error inesperado.' });
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo cancelar la hora.' });
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/IndexPac');
  };

  return (
    <Container>
      <GlobalStyles />
      <WizardPaso1 />
      <Content>
        <Title><strong>Reserva tu hora de Evaluación Dental Inicial</strong></Title>
        <Subtitle><strong>¿Quién es el paciente?</strong> Ingresa los datos de la persona que recibirá atención dental</Subtitle>
        {authMessage && <AuthMessage>{authMessage}</AuthMessage>}

        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="rut" className="label-text"><strong>RUT de Paciente</strong></Label>
              <Input
                type="text"
                id="rut"
                value={rut}
                onChange={handleRutChange}
                onBlur={handleRutBlur}
                maxLength="12"
                placeholder="Ejemplo: 12.345.678-5"
                className="input-border"
              />

            <div className="alert alert-info mt-3 text-center" role="alert" style={{ fontSize: '14px', backgroundColor: '#E8F8F9', borderColor: '#00A3AD', color: '#00788C', borderRadius: '10px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)', lineHeight: '1.5' }}>
              Esta plataforma es para agendar una evaluación dental.
              <br />
              <strong>Si eres paciente</strong> activo en tratamiento debes llamar al <strong>+56 9 3865 6876</strong>.
            </div>
          </FormGroup>

          <Spacer />
          <Divider />
          <ButtonGroupStyled>
            <Button type="submit" disabled={isButtonDisabled}>Siguiente</Button>
          </ButtonGroupStyled>
        </Form>
      </Content>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton />
        <Modal.Body>
          {agendamiento && (
            <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
              <h5 style={{ textAlign: 'center', color: '#00788C', marginBottom: '20px', fontWeight: 600 }}>
                <strong>{pacienteNombre}</strong>, hemos encontrado una hora programada para ti
              </h5>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '25px' }}>
                {/* Datos de Atención */}
                <div style={{ backgroundColor: '#E8F8F9', padding: '15px', borderRadius: '8px' }}>
                  <ModalCardTitle>
                    <img src="/agenda/images/ico_atencion.png" alt="icono atencion" style={{ width: '24px', marginRight: '8px' }} />
                    Información de la Atención
                  </ModalCardTitle>                  
                  <ModalText>
                    {agendamiento.ODONT_NOMBRES} {agendamiento.ODONT_APELLIDOS}
                  </ModalText>
                  <ModalSubText>
                    <strong style={{ color: "#4A4A4A" }}>Tipo de Atención:</strong> Evaluación Dental
                  </ModalSubText>
                </div>

                {/* Detalles Cita */}
                <div style={{ backgroundColor: '#E8F8F9', padding: '15px', borderRadius: '8px' }}>
                  <ModalCardTitle>
                    <img src="/agenda/images/ico_atencion.png" alt="icono cita" style={{ width: '24px', marginRight: '8px' }} />
                    Detalles de tu Cita
                  </ModalCardTitle>
                  <ModalInfoText>
                    <strong>Fecha:</strong> {formatearFecha(agendamiento.FECHA)}
                  </ModalInfoText>
                  <ModalInfoText>
                    <i className="fas fa-map-marker-alt icono-cyan"></i> <strong>Sucursal:</strong> {agendamiento.SUCURSAL}
                  </ModalInfoText>
                  <ModalInfoText>
                    <i className="far fa-clock icono-cyan"></i> <strong>Hora:</strong> {agendamiento.HORARIO}
                  </ModalInfoText>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <Button onClick={handleConfirmarAsistencia}>Confirmar mi Asistencia</Button>
                <Button onClick={handleCancelarHora} style={{ backgroundColor: '#f1f1f1', color: '#4A4A4A' }}>Cancelar mi Hora</Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default IndexPac;
